import React from 'react';
import { CLASSIFICATION } from './form/constants';

export const RadioButton = ({
  onChange,
  isReadOnly,
  isDisabled,
  isUnclassified
}) => {

  const setFOUO = () => {
      if (isUnclassified) {
          onChange(CLASSIFICATION.FOUO)
      }
  }

  const setUnclassified = () => {
      if (!isUnclassified) {
          onChange(CLASSIFICATION.UNCLASSIFIED)
      }
  }

  return (
      <div>
          <div style={{textAlign: 'center', fontWeight: 'bold'}}>Classification</div>
          <div className="cols-3">
              <div className="row checkbox">
                  <label>{CLASSIFICATION.FOUO}</label>
                  <input 
                      type="checkbox" 
                      checked={!isUnclassified}  
                      onClick={isReadOnly? null : setFOUO}
                      readOnly={isReadOnly}
                      disabled={isDisabled}
                      onChange={() => null}/>
                  <span className="checkmark"></span>
              </div>
              <div className="row checkbox">
                  <label>{CLASSIFICATION.UNCLASSIFIED}</label>
                  <input 
                      type="checkbox" 
                      checked={isUnclassified} 
                      onClick={isReadOnly ? null : setUnclassified} 
                      readOnly={isReadOnly}
                      disabled={isDisabled}
                      onChange={() => null}/>
                  <span className="checkmark"></span>
              </div>
          </div>
      </div>
  )
}
